const getters = {
  distributionFlag: state => state.user.distributionFlag
};
export default getters